(() => {
  'use strict';

  /* ZONES DE POINTURE */

  const EUROPEAN_COUNTRIES = new Set([
    'AD', 'AL', 'AT', 'AX', 'BA', 'BE', 'BG', 'BY', 'CH', 'CZ',
    'DE', 'DK', 'EE', 'ES', 'FI', 'FO', 'FR', 'GG', 'GI', 'GR',
    'HR', 'HU', 'IE', 'IM', 'IS', 'IT', 'JE', 'LI', 'LT', 'LU',
    'LV', 'MC', 'MD', 'ME', 'MK', 'MT', 'NL', 'NO', 'PL', 'PT',
    'RO', 'RS', 'RU', 'SE', 'SI', 'SJ', 'SK', 'SM', 'UA', 'VA',
    'XK'
  ]);

  const countryCode = (
    document.body?.dataset.lwCountry || ''
  ).toUpperCase();

  const locale = (
    document.body?.dataset.lwLocale || 'en'
  ).toLowerCase();

  const sizingZone =
    countryCode === 'GB'
      ? 'uk'
      : EUROPEAN_COUNTRIES.has(countryCode)
        ? 'europe'
        : 'world';


  /* LECTURE DE LA POINTURE SHOPIFY */

  const parseSize = (rawValue) => {
    const segments = String(rawValue || '')
      .split('|')
      .map((segment) => segment.trim());

    const euSegment = segments.find((segment) =>
      /\bEU\b/i.test(segment)
    );

    const usSegment = segments.find((segment) =>
      /\bUS\b/i.test(segment)
    );

    const ukSegment = segments.find((segment) =>
      /\bUK\b/i.test(segment)
    );

    if (!euSegment || !usSegment || !ukSegment) return null;

    const eu = euSegment
      .replace(/\bEU\b.*$/i, '')
      .trim();

    const uk = ukSegment
      .replace(/\bUK\b.*$/i, '')
      .trim();

    const usParts = usSegment.split(/\bUS\b/i);
    const us = (usParts[0] || '').trim();
    const usType = (usParts[1] || '').trim();

    return {
      eu,
      uk,
      us,
      usType,
      originalUs: usSegment
    };
  };


  /* FORMAT LOCALISÉ */

  const formatSize = (rawValue, context = 'picker') => {
    const parsed = parseSize(rawValue);

    if (!parsed) {
      return String(rawValue || '').trim();
    }

    if (sizingZone === 'europe') {
      return parsed.eu ? `EU ${parsed.eu}` : '';
    }

    if (sizingZone === 'uk') {
      return parsed.uk ? `UK ${parsed.uk}` : '';
    }

    if (context === 'cart') {
      return parsed.originalUs;
    }

    if (/\bGS\b/i.test(parsed.us)) {
      return `GS ${parsed.us
        .replace(/\bGS\b/gi, '')
        .trim()}`;
    }

    if (/^K/i.test(parsed.usType)) {
      return parsed.us ? `US ${parsed.us}` : '';
    }

    const typeInitial = parsed.usType
      .charAt(0)
      .toUpperCase();

    return parsed.us
      ? `US${typeInitial ? ` ${typeInitial}` : ''} ${parsed.us}`
      : '';
  };


  /* SUPPRESSION DES CHOIX INVALIDES */

  const removePickerChoice = (textNode) => {
    const choice = textNode.closest('label, a');

    if (!choice) return;

    const inputId = choice.getAttribute('for');

    if (inputId) {
      document.getElementById(inputId)?.remove();
    }

    choice.remove();
  };

  /* CONSEIL DE POINTURE */

  const updateSizeHelp = (fieldset, displayedSizes) => {
    const productInfo = fieldset.closest('[data-lw-product-context]');

    if (productInfo?.dataset.lwProductContext !== 'main_product') return;

    const helpBlock = productInfo.querySelector(
      '[data-block-type="lw-size-help"]'
    );
    const helpText = helpBlock?.querySelector('[data-lw-size-help]');

    if (!helpBlock) return;

    if (!helpText || displayedSizes.size === 0) {
      helpBlock.hidden = true;
      return;
    }

    const systems = new Set(
      Array.from(displayedSizes, (size) => {
        const match = size.match(/^(EU|UK|US M|US W)\s+(?=\d)/i);
        return match
          ? match[1].toLowerCase().replace(' ', '-')
          : 'eu';
      })
    );

    const system = systems.size === 1 ? Array.from(systems)[0] : 'eu';
    const language = locale.startsWith('fr') ? 'fr' : 'en';
    const message = (
      helpText.getAttribute(`data-lw-text-${system}-${language}`) || ''
    ).trim();

    if (helpText.textContent !== message) {
      helpText.textContent = message;
    }

    helpBlock.hidden = message === '';
  };


  /* SÉLECTEUR DE POINTURE */

  const localizePicker = (picker) => {
    picker
      .querySelectorAll('[data-lw-size-option]')
      .forEach((fieldset) => {
        const displayedSizes = new Set();

        const sizeNodes = fieldset.querySelectorAll([
          '.variant-picker__option-values label.block-swatch > span:last-child',
          '.variant-picker__option-values a.block-swatch > span:last-child',
          '.variant-picker__option-values label.block-underline > span:last-child',
          '.variant-picker__option-values a.block-underline > span:last-child',
          '.popover__value-option > span:first-child'
        ].join(','));

        sizeNodes.forEach((node) => {
          if (!node.dataset.lwOriginalSize) {
            node.dataset.lwOriginalSize =
              node.textContent.trim();
          }

          const displayValue = formatSize(
            node.dataset.lwOriginalSize,
            'picker'
          );

          const pureValue = displayValue
            .replace(
              /^(EU|UK|US(?:\s+[A-Z])?|GS)\s*/i,
              ''
            )
            .trim();

          const choice = node.closest('label, a');

          const isDisabled =
            choice?.classList.contains('is-disabled');

          if (!displayValue || pureValue === '-') {
            removePickerChoice(node);
            return;
          }

          if (
            !isDisabled &&
            displayedSizes.has(displayValue)
          ) {
            removePickerChoice(node);
            return;
          }

          if (!isDisabled) {
            displayedSizes.add(displayValue);
          }

          if (node.textContent !== displayValue) {
            node.textContent = displayValue;
          }
        });


        /* POINTURE SÉLECTIONNÉE */

        const selectedValue = fieldset.querySelector(
          '.select [id$="-selected-value"]'
        );

        if (selectedValue) {
          const currentValue =
            selectedValue.textContent.trim();

          if (
            !selectedValue.dataset.lwOriginalSize ||
            (
              selectedValue.dataset.lwDisplaySize &&
              currentValue !==
                selectedValue.dataset.lwDisplaySize
            )
          ) {
            selectedValue.dataset.lwOriginalSize =
              currentValue;
          }

          const displayValue = formatSize(
            selectedValue.dataset.lwOriginalSize,
            'picker'
          );

          selectedValue.dataset.lwDisplaySize =
            displayValue;

          if (
            displayValue &&
            currentValue !== displayValue
          ) {
             selectedValue.textContent = displayValue;
          }
        }
        updateSizeHelp(fieldset, displayedSizes);
      });
  };


  /* POINTURES DANS LE PANIER */

  const localizeLineItems = (root = document) => {
    const nodes = [];

    if (
      root instanceof Element &&
      root.matches('[data-lw-size-value]')
    ) {
      nodes.push(root);
    }

    root
      .querySelectorAll?.('[data-lw-size-value]')
      .forEach((node) => {
        nodes.push(node);
      });

    nodes.forEach((node) => {
      const displayValue = formatSize(
        node.dataset.lwSizeValue,
        'cart'
      );

      if (
        displayValue &&
        node.textContent !== displayValue
      ) {
        node.textContent = displayValue;
      }
    });
  };


  /* PRODUITS EN RUPTURE */

  const setSoldOutState = (productInfo) => {
    const pickerBlock = productInfo.querySelector(
      '[data-block-type="variant-picker"]'
    );

    const buyButton = productInfo.querySelector(
      '.buy-buttons button[type="submit"]'
    );

    if (!pickerBlock || !buyButton) return;

    const availableChoices = pickerBlock.querySelectorAll(
      '[data-lw-size-option] label:not(.is-disabled):not([hidden]), ' +
      '[data-lw-size-option] a:not(.is-disabled):not([hidden])'
    );

    if (availableChoices.length > 0) return;

    pickerBlock.remove();

    buyButton.disabled = true;

    buyButton.textContent = locale.startsWith('fr')
      ? 'En rupture'
      : 'Sold out';

    const paymentButton = productInfo.querySelector(
      '[data-shopify="payment-button"]'
    );

    if (paymentButton) {
      paymentButton.hidden = true;
    }
  };


  /* SÉLECTION OBLIGATOIRE */

  const initializeProductInfo = (productInfo) => {
    if (
      productInfo.dataset.lwProductContext !==
      'main_product'
    ) {
      return;
    }

    const sizeFieldset = productInfo.querySelector(
      '[data-lw-size-option]'
    );

    if (!sizeFieldset) return;

    setSoldOutState(productInfo);

    if (
      productInfo.dataset.lwSizeSelectionReady ===
      'true'
    ) {
      return;
    }

    productInfo.dataset.lwSizeSelectionReady = 'true';

    sizeFieldset
      .querySelectorAll('input[type="radio"]')
      .forEach((input) => {
        input.checked = false;
      });

    const warning = productInfo.querySelector(
      '[data-block-id="text_YrahQz"]'
    );

    const values = sizeFieldset.querySelector(
      '.variant-picker__option-values'
    );

    productInfo
      .querySelectorAll(
        '.buy-buttons button[type="submit"]'
      )
      .forEach((button) => {
        button.addEventListener(
          'click',
          (event) => {
            if (
              sizeFieldset.querySelector(
                'input[type="radio"]:checked'
              )
            ) {
              return;
            }

            event.preventDefault();

            if (warning) {
              warning.style.display = 'flex';
            }

            if (values) {
              values.classList.remove(
                'loumy-size-shake'
              );

              void values.offsetWidth;

              values.classList.add(
                'loumy-size-shake'
              );

              window.setTimeout(() => {
                values.classList.remove(
                  'loumy-size-shake'
                );
              }, 300);
            }
          }
        );
      });

    sizeFieldset.addEventListener('change', () => {
      if (warning) {
        warning.style.display = 'none';
      }
    });
  };


  /* RAFRAÎCHISSEMENT DES ÉLÉMENTS */

  const refresh = (root = document) => {
    const pickers = [];
    const productInfos = [];

    if (
      root instanceof Element &&
      root.matches('variant-picker')
    ) {
      pickers.push(root);
    }

    if (
      root instanceof Element &&
      root.matches('[data-lw-product-context]')
    ) {
      productInfos.push(root);
    }

    root
      .querySelectorAll?.('variant-picker')
      .forEach((picker) => {
        pickers.push(picker);
      });

    root
      .querySelectorAll?.(
        '[data-lw-product-context]'
      )
      .forEach((productInfo) => {
        productInfos.push(productInfo);
      });

    pickers.forEach(localizePicker);
    localizeLineItems(root);
    productInfos.forEach(initializeProductInfo);
  };


  /* RAFRAÎCHISSEMENT GROUPÉ */

  let refreshQueued = false;

  const queueRefresh = () => {
    if (refreshQueued) return;

    refreshQueued = true;

    window.requestAnimationFrame(() => {
      refreshQueued = false;
      refresh(document);
    });
  };


  /* INITIALISATION */

  const start = () => {
    refresh(document);


    /* LIEN RETOUR */

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const backLink = event.target.closest(
        '[data-lw-back-link]'
      );

      if (!backLink || !document.referrer) return;

      try {
        const previousUrl =
          new URL(document.referrer);

        if (
          previousUrl.origin ===
          window.location.origin
        ) {
          event.preventDefault();
          window.history.back();
        }
      } catch (_error) {
        /* ACCUEIL EN SOLUTION DE SECOURS */
      }
    });


    /* MISES À JOUR DYNAMIQUES SHOPIFY */

    new MutationObserver(queueRefresh).observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  };


  /* DÉMARRAGE */

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      {
        once: true
      }
    );
  } else {
    start();
  }
})();